/* Back9Relief cart drawer.
 *
 * Reads /cart.js, draws the lines, and keeps the insole bundle honest:
 * pairs only ever rest on 1, 3 or 5 (the three tiers), and the free gifts
 * follow the tier. Every change is one /cart/update.js call - insole
 * quantities keyed by line, gifts keyed by variant - so there is one round
 * trip and one repaint per press.
 *
 * Shopify's Buy X Get Y splits the free pairs onto their own line; the
 * drawer folds them back into the paid card and labels them.
 *
 * Public API for the product page: window.b9rCart.open() / .refresh().
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-b9r-cart]');
  if (!root) return;

  var INSOLE_PRODUCT_ID = parseInt(root.getAttribute('data-insoles'), 10) || 7757685293150;
  /* the price-test copy of the insoles (golfers-comfort-insoles-offer) is the
     same bundle; its own discounts make the extra pairs cheap, not free */
  var TEST_PRODUCT_ID = parseInt(root.getAttribute('data-insoles-test'), 10) || 0;
  function isInsole(id) { return id === INSOLE_PRODUCT_ID || (TEST_PRODUCT_ID && id === TEST_PRODUCT_ID); }
  var THRESHOLD = parseFloat(root.getAttribute('data-threshold')) || 0;
  var BONUSES_HEADING = root.getAttribute('data-bonuses-heading') || 'Your free bonuses';
  /* free shipping is one of the counted bonuses, so it gets a row in the
     list too - the same truck the product page shows, valued at the flat rate */
  var SHIP_IMAGE = root.getAttribute('data-ship-image') || '';
  var SHIP_VALUE = Math.round((parseFloat(root.getAttribute('data-ship-value')) || 0) * 100);

  /* gift variant -> the lowest tier that includes it */
  var GIFT = {
    43283209289822: 2,   // Foot Relief Sleeve
    41936396288094: 2,   // Pain-Free Golf Hacks (E-Book)
    43283209650270: 3    // Recovery Socks (2-Pack)
  };

  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var itemsEl = $('[data-b9c-items]');
  var emptyEl = $('[data-b9c-empty]');
  var footEl = $('[data-b9c-foot]');
  var countEl = $('[data-b9c-count]');
  var totalEl = $('[data-b9c-total]');
  var discEl = $('[data-b9c-discounts]');
  var discTags = $('[data-b9c-discount-tags]');
  var discAmt = $('[data-b9c-discount-amount]');
  var savingEl = $('[data-b9c-saving]');
  var savingTotal = $('[data-b9c-saving-total]');
  var savingGifts = $('[data-b9c-saving-gifts]');
  var shipEl = $('[data-b9c-ship]');
  var shipText = $('[data-b9c-ship-text]');
  var shipBar = $('[data-b9c-bar]');
  var shipIcon = $('.b9c__bar-icon');
  var upsellsEl = $('[data-b9c-upsells]');
  var panel = $('.b9c__panel');

  var BLURBS = {};
  try { BLURBS = JSON.parse(($('[data-b9c-blurbs]') || {}).textContent || '{}'); } catch (e) {}
  function lineImage(it, w) { return imgSrc(it.image, w); }

  var cart = null;
  var busy = false;
  var renderGen = 0;
  var bonusOpen = false;   // the free-bonus list, collapsed until tapped
  /* the same count the product page shows ("+ 5 FREE Bonuses"): each pair in
     a pack counts, and free shipping counts once it is unlocked */
  var GIFT_COUNT = { 43283209650270: 2 };   // Recovery Socks (2-Pack)
  function freeShipping(c) {
    if (!(THRESHOLD > 0)) return false;
    var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    return c.total_price >= Math.round(THRESHOLD * rate * 100);
  }
  function bonusCount(c, gifts) {
    return gifts.reduce(function (n, it) { return n + it.quantity * (GIFT_COUNT[it.variant_id] || 1); }, 0) + (freeShipping(c) ? 1 : 0);
  }
  function bonusLabel(n) { return n + ' Bonus' + (n === 1 ? '' : 'es') + ' Included'; }
  var productCache = {};   // handle -> /products/x.js

  var ICON_GIFT = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h14v9H3zM2 5.5h16V8H2zM10 5.5v11.5M10 5.5C8 5.5 5.8 4.6 6.3 3.2 6.8 1.8 9.3 3.2 10 5.5zm0 0c2 0 4.2-.9 3.7-2.3-.5-1.4-3-.1-3.7 2.3z"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 5.5h13M8 5.5V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5M5 5.5l.7 10.1a1 1 0 0 0 1 .9h6.6a1 1 0 0 0 1-.9l.7-10.1M8.2 8.5v5M11.8 8.5v5"/></svg>';

  /* ------------------------------------------------------------ utils -- */
  /* Prices the way Liquid prints them for this shopper: the section renders
     1.00 in the market's currency (e.g. "$1.00", "£1.00", "1,00 €") and the
     symbol, separators and decimals are read off that sample. */
  var moneyShape = (function () {
    var sample = (root.getAttribute('data-money-sample') || '$1.00').trim();
    var m = /^(.*?)1(?:([.,])(0+))?(.*)$/.exec(sample);
    if (!m) return { pre: '$', post: '', dec: '.', grp: ',', digits: 2 };
    var dec = m[2] || '.';
    return { pre: m[1], post: m[4], dec: dec, grp: dec === ',' ? '.' : ',', digits: m[3] ? m[3].length : 0 };
  })();
  function money(cents, whole) {
    var f = moneyShape;
    var digits = whole ? 0 : f.digits;
    var n = (Math.abs(cents || 0) / 100).toFixed(digits);
    var parts = n.split('.');
    var out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.grp) + (parts[1] ? f.dec + parts[1] : '');
    return (cents < 0 ? '-' : '') + f.pre + out + f.post;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fetchJSON(url, opts) {
    return window.fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }
  /* Shopify's analytics listener (Meta AddToCart, GA add_to_cart) only
     watches fetch(); a request through XMLHttpRequest changes the cart
     without being counted. Everything the drawer does goes this way: the
     only add-to-cart that counts is the product page's button. */
  function xhrJSON(url, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', url);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        if (x.status < 200 || x.status >= 300) { reject(new Error(url + ' ' + x.status)); return; }
        try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); }
      };
      x.onerror = function () { reject(new Error(url + ' failed')); };
      x.send(JSON.stringify(body));
    });
  }
  function imgSrc(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&height=' + w + '&crop=center';
  }
  /* "Golfer's Recovery Socks (2-Pair Pack)" -> name on one line, the bracket on the next */
  function nameHTML(title) {
    // the gift rows are narrow: drop the brand prefix on the two long names
    title = String(title || '').replace(/^Golfer(?:'|&#39;|’)s (Foot Relief Sleeve|Recovery Socks|Heel Guards)/, '$1');
    var m = /^(.*?)\s*(\([^)]*\))\s*$/.exec(title);
    if (!m) return esc(title);
    // the bracket becomes a small tag after the name, the same chip the product page uses
    return esc(m[1]) + ' <span class="b9c__name-sub">' + esc(m[2].replace(/^\(|\)$/g, '')) + '</span>';
  }
  /* the bonus rows read as a sentence, not a headline: "Compress away soreness" */
  function sentence(str) {
    str = String(str || '');
    return (str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()).replace(/\bachilles\b/g, 'Achilles');
  }
  /* Names and headings never wrap. A line that would is shrunk a step at a
     time (down to 11.5px), then clipped as a last resort. */
  function fitLines(scope) {
    Array.prototype.forEach.call((scope || root).querySelectorAll('.b9c__upsell-title, .b9c__upsell-blurb, .b9c__gift .b9c__name, .b9c__gift-blurb'), function (el) {
      if (el.offsetParent === null) return;   // hidden set or card: nothing to measure
      el.style.fontSize = '';
      var size = parseFloat(getComputedStyle(el).fontSize);
      while (el.scrollWidth > el.clientWidth && size > 11.5) {
        size -= 0.5;
        el.style.fontSize = size + 'px';
      }
    });
  }
  function tierFor(total) { return total >= 5 ? 3 : total >= 3 ? 2 : total >= 1 ? 1 : 0; }
  /* Between tiers there is no reason to stop (4 pairs cost the same as 5),
     so 2 and 4 snap. Past 5 the bundle is spent and pairs are counted one
     at a time at full price. */
  function snapDown(total) { return total >= 5 ? total : total >= 3 ? 3 : total >= 1 ? 1 : 0; }
  function stepUp(total) { return total >= 5 ? total + 1 : total >= 3 ? 5 : total >= 1 ? 3 : 1; }
  function stepDown(total) { return total > 5 ? total - 1 : total > 3 ? 3 : total > 1 ? 1 : 0; }

  /* compare-at prices are not in /cart.js; one products.js per handle, and
     the answer is kept in a sync map so a re-render never has to wait. */
  var cmpMap = {};   // variant_id -> compare_at cents
  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetchJSON('/products/' + handle + '.js').then(function (p) {
        (p.variants || []).forEach(function (v) { cmpMap[v.id] = v.compare_at_price || 0; });
        return p;
      }).catch(function () { return null; });
    }
    return productCache[handle];
  }
  function compareSync(item) { return cmpMap[item.variant_id] || null; }
  function known(item) { return Object.prototype.hasOwnProperty.call(cmpMap, item.variant_id); }
  function compareAt(item) {
    return loadProduct(item.handle).then(function () { return compareSync(item); });
  }
  // free-gift product -> the paid product it duplicates
  var GIFT_TWIN = { 7760276324446: 7470454800478, 7760276258910: 7627692539998, 15497937518686: 7470454472798 };
  // fallback order while a price is still unknown (higher = earlier)
  var GIFT_RANK = { 43283209650270: 3, 43283209289822: 2, 41936396288094: 1 };

  /* Black Friday / Cyber Monday 2026. No Shopify discount: like the tier
     gifts, the bonuses are $0 copies the drawer adds and takes away, and
     anything not earned is taken back out. Days are Eastern time.
       Nov 23-30, early-access list (their email link carries ?b9vip=1):
         free Heel Guards with 3+ pairs or a Relief Kit
       Black Friday Week, Mon Nov 23 - Sun Nov 29, everyone: 2 free pairs
         with each kit, in the kit's size (Julian, Nov 2: ads run all week)
       Mon Nov 30, everyone: the Heel Guards, on the same terms
     The free pairs product is only active Nov 23-29 (a draft before and
     after), so its variants cannot be bought outside the week. */
  var HEEL_GIFT = 67909141659742;
  var KIT_PRODUCT_ID = 7758881390686;
  var KIT_PAIR = {};     // kit variant -> the free pair in the same size
  var PAIR_GIFT = {};    // free-pair variants
  var KIT_SIZES = [43260776054878, 43260776087646, 43260776120414, 43260776153182, 43260776185950, 43260776218718,
                   43260776251486, 43260776284254, 43260776317022, 43260776349790, 43260776382558];   // US 5 ... US 15 (men's)
  var PAIR_SIZES = [67909141725278, 67909141758046, 67909141790814, 67909141823582, 67909141856350, 67909141889118,
                    67909141921886, 67909141954654, 67909141987422, 67909142020190, 67909142052958];  // M 5 / W 6 ... M 15 / W 16
  KIT_SIZES.forEach(function (kit, i) { KIT_PAIR[kit] = PAIR_SIZES[i]; PAIR_GIFT[PAIR_SIZES[i]] = true; });
  var onPreview = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main');
  function readStore(kind, key) { try { return window[kind].getItem(key); } catch (e) { return null; } }
  function writeStore(kind, key, val) { try { window[kind].setItem(key, val); } catch (e) {} }
  if (/[?&]b9vip=1(&|$)/.test(location.search)) writeStore('localStorage', 'b9r-vip', '1');
  // a preview theme can stand in for any day: ?b9day=2026-11-27 (never on the live theme)
  var testDay = onPreview && /[?&]b9day=(\d{4}-\d\d-\d\d)/.exec(location.search);
  if (testDay) writeStore('sessionStorage', 'b9r-day', testDay[1]);
  function today() {
    var t = onPreview && readStore('sessionStorage', 'b9r-day');
    if (t) return t;
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { return ''; }
  }
  function promoGift(it) { return it.variant_id === HEEL_GIFT || PAIR_GIFT[it.variant_id]; }
  /* the BF/CM gifts the cart has earned on `tier`, as update.js entries */
  function promoUpdates(c, tier) {
    var day = today();
    var vip = readStore('localStorage', 'b9r-vip') === '1';
    var want = {}, kits = 0;
    c.items.forEach(function (it) {
      if (it.product_id !== KIT_PRODUCT_ID) return;
      kits += it.quantity;
      var pair = KIT_PAIR[it.variant_id];
      if (day >= '2026-11-23' && day <= '2026-11-29' && pair) want[pair] = (want[pair] || 0) + 2 * it.quantity;
    });
    var heelDay = day === '2026-11-30' || (vip && day >= '2026-11-23' && day <= '2026-11-30');
    if (heelDay && (tier >= 2 || kits)) want[HEEL_GIFT] = 1;
    var updates = {}, seen = {};
    c.items.forEach(function (it) {
      if (!promoGift(it)) return;
      var q = seen[it.variant_id] ? 0 : (want[it.variant_id] || 0);   // one line per gift
      seen[it.variant_id] = true;
      if (q !== it.quantity) updates[it.key] = q;
    });
    Object.keys(want).forEach(function (vid) { if (!seen[vid]) updates[vid] = want[vid]; });
    return updates;
  }
  function merge(a, b) { Object.keys(b).forEach(function (k) { a[k] = b[k]; }); return a; }

  /* ------------------------------------------------------------ model -- */
  function model(c) {
    var groups = {};   // insoles by variant
    var gifts = [];
    var others = [];
    c.items.forEach(function (it) {
      if (isInsole(it.product_id)) {
        var g = groups[it.variant_id] || (groups[it.variant_id] = { item: it, lines: [], qty: 0, free: 0, paid: 0, paidTotal: 0, test: it.product_id === TEST_PRODUCT_ID });
        g.lines.push(it);
        g.qty += it.quantity;
        // free units = discount / unit price (Shopify splits them out, but be safe)
        var unit = it.original_price || 0;
        var freeUnits = unit ? Math.round((it.original_line_price - it.final_line_price) / unit) : 0;
        g.free += freeUnits;
        g.paid += it.quantity - freeUnits;
        g.paidTotal += it.final_line_price;
      } else if (it.final_line_price === 0) {
        gifts.push(it);
      } else {
        others.push(it);
      }
    });
    var insoles = Object.keys(groups).map(function (k) { return groups[k]; });
    var total = insoles.reduce(function (a, g) { return a + g.qty; }, 0);
    return { insoles: insoles, gifts: gifts, others: others, total: total, tier: tierFor(total) };
  }

  /* ----------------------------------------------------------- render -- */
  function lineHTML(o) {
    return '' +
      '<div class="b9c__line' + (o.cls || '') + '" ' + (o.attrs || '') + '>' +
        '<div class="b9c__img">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" decoding="sync">' : '') + '</div>' +
        '<div class="b9c__body">' +
          '<div class="b9c__row"><div>' +
            '<div class="b9c__name">' + nameHTML(o.title) + '</div>' +
            (o.blurb ? '<div class="b9c__blurb">' + esc(o.blurb) + '</div>' : '') +
            (o.variantHTML ? '<div class="b9c__var">' + o.variantHTML + '</div>' : o.variant ? '<div class="b9c__var">' + esc(o.variant) + '</div>' : '') +
          '</div>' +
          (o.removeAttr ? '<button type="button" class="b9c__remove" aria-label="Remove" ' + o.removeAttr + '>' + ICON_TRASH + '</button>' : '') +
          '</div>' +
          '<div class="b9c__ctl">' + (o.ctl || '') +
            '<div class="b9c__right"><div class="b9c__price" data-b9c-price>' + o.price + '</div>' + (o.pill || '') + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }
  function priceHTML(compare, price) {
    var h = '';
    if (compare != null && compare > price) h += '<s>' + money(compare) + '</s> ';
    h += '<b>' + money(price) + '</b>';
    return h;
  }
  function qtyHTML(qty, minusAttr, plusAttr, plusDisabled) {
    return '<span class="b9c__qty">' +
      '<button type="button" aria-label="Decrease quantity" ' + minusAttr + '>&minus;</button>' +
      '<output>' + qty + '</output>' +
      '<button type="button" aria-label="Increase quantity" ' + plusAttr + (plusDisabled ? ' disabled' : '') + '>+</button>' +
    '</span>';
  }

  function render() {
    var c = cart;
    var m = model(c);
    var html = '';

    /* One card for the insoles however many sizes are in it. Shopify parks
       the free pair on whichever size line it likes; the shopper should see
       one bundle: sizes, total pairs, what they pay. */
    if (m.insoles.length) {
      var first = m.insoles[0].item;
      var qty = 0, paid = 0, free = 0, paidTotal = 0, cmpTotal = 0, cmpKnown = true;
      var sizes = [], sizeLabel = 'Size (US)';
      m.insoles.forEach(function (g) {
        qty += g.qty; paid += g.paid; free += g.free; paidTotal += g.paidTotal;
        var cmp = compareSync(g.item);
        if (cmp) cmpTotal += cmp * g.qty; else cmpKnown = false;
        // a shopper who picked "UK 8" sees "UK 8", not the US variant name
        var props = g.item.properties || {};
        var local = props['Size (UK)'] || props['Size (EU)'];
        if (local) sizeLabel = props['Size (UK)'] ? 'Size (UK)' : 'Size (EU)';
        if (local || g.item.variant_title) sizes.push('<b>' + g.qty + '×</b> ' + esc(local || g.item.variant_title));
      });
      /* the test copy spreads its discount over every extra pair, so the
         split comes from the offer: 3 pairs = 2 + 1, 5 pairs = 3 + 2 */
      if (m.insoles[0].test) { free = qty >= 5 ? 2 : qty >= 3 ? 1 : 0; paid = qty - free; }
      var pill = free ? '<span class="b9c__pill">' + paid + ' paid + ' + free + ' free</span>' : '';
      html += lineHTML({
        attrs: 'data-b9c-group="insoles"',
        img: imgSrc(first.image, 160), title: first.product_title,
        variantHTML: sizes.length ? (sizes.length > 1 ? sizeLabel + '<ul class="b9c__sizes"><li>' + sizes.join('</li><li>') + '</li></ul>' : sizeLabel + ': ' + sizes[0].replace(/^<b>\d+×<\/b> /, '')) : '',
        removeAttr: 'data-b9c-act="remove-insoles"',
        price: priceHTML(cmpKnown ? cmpTotal : null, paidTotal),
        ctl: qtyHTML(qty, 'data-b9c-act="minus"', 'data-b9c-act="plus"', false),
        pill: pill
      });
    }

    /* on Black Friday the kit's own 2 pairs are spelled out, so the free
       pairs below read as extra and not as all the insoles they get */
    var bfPairs = m.gifts.some(function (it) { return PAIR_GIFT[it.variant_id]; });
    m.others.forEach(function (it) {
      html += lineHTML({
        attrs: 'data-b9c-key="' + esc(it.key) + '"',
        img: lineImage(it, 160), title: it.product_title, variant: it.variant_title,
        blurb: bfPairs && it.product_id === KIT_PRODUCT_ID ? 'Includes 2 Pairs of Insoles' : BLURBS[it.handle] || '',
        removeAttr: 'data-b9c-act="line" data-b9c-key="' + esc(it.key) + '" data-b9c-qty="0"',
        price: priceHTML(compareSync(it) ? compareSync(it) * it.quantity : null, it.final_line_price),
        ctl: qtyHTML(it.quantity,
          'data-b9c-act="line" data-b9c-key="' + esc(it.key) + '" data-b9c-qty="' + (it.quantity - 1) + '"',
          'data-b9c-act="line" data-b9c-key="' + esc(it.key) + '" data-b9c-qty="' + (it.quantity + 1) + '"')
      });
    });

    /* gifts: most valuable first, e-book last - drawn in the same pass as
       everything else so the column never jumps. */
    if (m.gifts.length) {
      var rows = m.gifts.map(function (it) {
        return { it: it, cmp: compareSync(it) || 0, rank: GIFT_RANK[it.variant_id] || 0 };
      });
      rows.sort(function (a, b) { return (b.cmp - a.cmp) || (b.rank - a.rank); });
      var tpl = root.querySelector('[data-b9c-bonus-head]');
      var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
      var shipWorth = freeShipping(c) ? Math.round(SHIP_VALUE * rate) : 0;
      var worth = rows.reduce(function (sum, r) { return sum + r.cmp * r.it.quantity; }, 0) + shipWorth;
      /* collapsed by default: the product page already sold the bonuses in
         full, here they are confirmation, and the box was pushing the
         recommendations below the fold on the 5-pair tier. The header keeps
         the count and the value; a tap opens the list. */
      html += '<div class="b9c__bonus' + (bonusOpen ? ' is-open' : '') + '">' +
        '<button type="button" class="b9c__bonus-toggle" data-b9c-act="bonus" aria-expanded="' + (bonusOpen ? 'true' : 'false') + '">' +
          '<div class="b9c__bonus-head"><span class="b9c__bonus-icon" aria-hidden="true">' + (tpl && tpl.content.querySelector('.b9c__bonus-icon') ? tpl.content.querySelector('.b9c__bonus-icon').innerHTML : ICON_GIFT) + '</span><span data-b9c-bonus-label>' + esc(bonusLabel(bonusCount(c, m.gifts))) + '</span></div>' +
          '<span class="b9c__bonus-meta">' + (worth ? '<span class="b9c__bonus-worth">' + money(worth, worth % 100 === 0) + ' value</span>' : '') +
          '<svg class="b9c__bonus-chev" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '</button><div class="b9c__bonus-list"' + (bonusOpen ? '' : ' hidden') + '>';
      rows.forEach(function (r) {
        var it = r.it;
        html += '<div class="b9c__gift" data-b9c-key="' + esc(it.key) + '">' +
          '<div class="b9c__img">' + (it.image ? '<img src="' + esc(lineImage(it, 120)) + '" alt="" decoding="sync">' : '') + '</div>' +
          '<div class="b9c__name">' + nameHTML(PAIR_GIFT[it.variant_id] ? '+' + it.quantity + ' Extra Pairs' : it.product_title) + '</div>' +
          '<span class="b9c__gift-val">' + (r.cmp ? '<s>' + money(r.cmp * it.quantity) + '</s>' : '') + '<span class="b9c__pill">Free</span></span>' +
          // the kit's 2 pairs per kit plus these: 4 per kit in all
          (PAIR_GIFT[it.variant_id] ? '<div class="b9c__gift-blurb">Black Friday · ' + it.quantity * 2 + ' Pairs Total</div>'
            : BLURBS[it.handle] ? '<div class="b9c__gift-blurb">' + esc(BLURBS[it.handle]) + '</div>' : '') +
        '</div>';
      });
      if (shipWorth) {
        html += '<div class="b9c__gift b9c__gift--ship">' +
          '<div class="b9c__img">' + (SHIP_IMAGE ? '<img src="' + esc(SHIP_IMAGE) + '" alt="" decoding="sync">' : '') + '</div>' +
          '<div class="b9c__name">Free Shipping</div>' +
          '<span class="b9c__gift-val"><s>' + money(shipWorth) + '</s><span class="b9c__pill">Free</span></span>' +
          '<div class="b9c__gift-blurb">Tracked, On Us</div>' +
        '</div>';
      }
      html += '</div></div>';
      // a rule under the box, like the one under the shipping bar, so the
      // chevron reads as "open this" and not "the products below"
      html += '<hr class="b9c__rule">';
    }

    swapItems(html);

    // first sight of a product: fetch its compare-at once, then redraw once
    var toLoad = c.items.filter(function (it) { return it.handle && !known(it); });
    if (toLoad.length) {
      var gen = ++renderGen;
      Promise.all(toLoad.map(function (it) { return loadProduct(it.handle); })).then(function () {
        // repaint with whatever the cart is now; a newer render has already picked the prices up
        if (gen === renderGen && cart) render();
      });
    }
    var empty = !c.item_count;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;
    if (upsellsEl) {
      var inCart = {};
      c.items.forEach(function (it) {
        inCart[it.product_id] = true;
        if (GIFT_TWIN[it.product_id]) inCart[GIFT_TWIN[it.product_id]] = true;   // free socks in cart = socks in cart
      });
      /* which set: the rule for the first product the shopper added
         (/cart.js lists newest first, so that is the last paid line),
         else the default set */
      var paid = c.items.filter(function (it) { return it.final_line_price > 0 || isInsole(it.product_id); });
      var mainId = paid.length ? paid[paid.length - 1].product_id : null;
      if (mainId && mainId === TEST_PRODUCT_ID) mainId = INSOLE_PRODUCT_ID;   // same upsells as the insoles
      var set = (mainId && upsellsEl.querySelector('[data-b9c-set="' + mainId + '"]')) || upsellsEl.querySelector('[data-b9c-set="default"]');
      var any = false;
      Array.prototype.forEach.call(upsellsEl.querySelectorAll('[data-b9c-set]'), function (grp) {
        var on = grp === set;
        grp.hidden = !on;
        Array.prototype.forEach.call(grp.querySelectorAll('[data-b9c-upsell]'), function (u) {
          var hide = !!inCart[parseInt(u.getAttribute('data-product-id'), 10)];
          u.hidden = hide;
          if (on && !hide) any = true;
        });
      });
      upsellsEl.hidden = empty || !any;
    }
    if (!root.hidden) fitLines();
    countEl.textContent = c.item_count ? String(c.item_count) : '';
    syncHeaderBubble(c.item_count);
    totalEl.textContent = money(c.total_price);

    // discounts
    var titles = {};
    c.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (d) {
        if (d.discount_application && d.discount_application.title) titles[d.discount_application.title] = true;
      });
    });
    (c.cart_level_discount_applications || []).forEach(function (d) { if (d.title) titles[d.title] = true; });
    var names = Object.keys(titles);
    if (c.total_discount > 0 && names.length) {
      discTags.innerHTML = names.map(function (n) { return '<span>' + esc(n) + '</span>'; }).join('');
      discAmt.textContent = '- ' + money(c.total_discount);
      discEl.hidden = false;
    } else {
      discEl.hidden = true;
    }

    // total savings: compare-at gap on everything paid, plus the gifts' value
    if (savingEl) {
      var saved = 0, giftsVal = 0;
      m.insoles.forEach(function (g) { var cmp = compareSync(g.item); if (cmp) saved += cmp * g.qty - g.paidTotal; });
      m.others.forEach(function (it) { var cmp = compareSync(it); if (cmp) saved += Math.max(0, cmp * it.quantity - it.final_line_price); });
      m.gifts.forEach(function (it) { var cmp = compareSync(it); if (cmp) giftsVal += cmp * it.quantity; });
      saved += giftsVal;
      if (saved > 0) {
        savingTotal.textContent = money(saved);
        savingGifts.textContent = giftsVal ? ', incl. ' + money(giftsVal) + ' in free gifts' : '';
        savingEl.hidden = false;
      } else {
        savingEl.hidden = true;
      }
    }

    // free shipping
    if (shipEl && THRESHOLD > 0) {
      // threshold is in USD; Shopify's conversion rate turns it into the cart's currency
      var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
      var thr = Math.round(THRESHOLD * rate * 100);
      var have = c.total_price;
      var pct = Math.max(0, Math.min(100, have / thr * 100));
      shipBar.style.width = pct + '%';
      if (shipIcon) shipIcon.style.left = pct + '%';
      shipText.innerHTML = have >= thr
        ? '<strong>Free Shipping Unlocked!</strong>'
        : 'You’re <strong>' + money(thr - have) + '</strong> away from <b>Free Shipping</b>';
      shipEl.classList.toggle('is-done', have >= thr);
      shipEl.hidden = empty;
    }

  }

  /* Replace the list but carry the existing <img> nodes over wherever the
     same picture is still needed - a fresh <img> repaints from blank for a
     frame even when cached, which reads as the thumbnail blinking. */
  function swapItems(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var had = {};
    Array.prototype.forEach.call(itemsEl.querySelectorAll('img'), function (img) { had[img.getAttribute('src')] = had[img.getAttribute('src')] || img; });
    Array.prototype.forEach.call(tpl.content.querySelectorAll('img'), function (img) {
      var old = had[img.getAttribute('src')];
      if (old) { img.parentNode.replaceChild(old, img); delete had[img.getAttribute('src')]; }
    });
    itemsEl.replaceChildren(tpl.content);
  }

  /* Shrine's header count only updates on page load; keep it in step */
  function syncHeaderBubble(n) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (!n) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      icon.appendChild(bubble);
    }
    bubble.children[0].textContent = n < 100 ? String(n) : '99+';
    bubble.children[1].textContent = n + (n === 1 ? ' item' : ' items');
  }

  /* ---------------------------------------------------------- changes -- */
  function setBusy(on) {
    busy = on;
    if (on) root.setAttribute('data-busy', ''); else root.removeAttribute('data-busy');
  }

  /* The cart, as a link that rebuilds it anywhere (a Shopify cart permalink), saved on the shopper's Klaviyo
     profile as "B9R Cart URL" each time it changes. The cart emails use it, so a cart built in the Instagram
     or Facebook browser comes back whole (every size, add-on and gift) when the email opens somewhere else.
     Only for shoppers Klaviyo already knows. An emptied cart saves "" and the emails fall back to the add. */
  var savedCartUrl = null;
  function rememberCart(c) {
    var k = window.klaviyo;
    if (!c || !k || typeof k.identify !== 'function' || typeof k.isIdentified !== 'function') return;
    var qty = {}, order = [];
    c.items.forEach(function (it) {
      // the BF/CM gifts are left out: the drawer puts them back if the day still earns them,
      // and the free pairs are a draft after Nov 29, which would break the link
      if (promoGift(it)) return;
      if (!qty[it.variant_id]) { qty[it.variant_id] = 0; order.push(it.variant_id); }
      qty[it.variant_id] += it.quantity;   // the free B2G1 pair is its own line: merged, the discount re-applies
    });
    var url = order.length ? 'https://back9relief.com/cart/' + order.map(function (v) { return v + ':' + qty[v]; }).join(',') + '?storefront=true' : '';
    if (url === savedCartUrl) return;
    savedCartUrl = url;
    Promise.resolve(k.isIdentified()).then(function (known) {
      if (known) k.identify({ 'B9R Cart URL': url, 'B9R Cart Updated': new Date().toISOString() });
    }, function () {});
  }

  function refresh() {
    return fetchJSON('/cart.js').then(function (c) {
      cart = c;
      render();
      rememberCart(c);
      return normalize(c);
    });
  }

  /* One update payload that puts the insole total on `target` and the
     gifts on the tier that total earns. `prefer` is the variant the press
     came from - it takes the change first. */
  function bundleUpdates(c, target, prefer) {
    var m = model(c);
    var updates = {};
    var delta = target - m.total;
    var order = m.insoles.slice().sort(function (a, b) {
      if (a.item.variant_id === prefer) return -1;
      if (b.item.variant_id === prefer) return 1;
      return b.qty - a.qty;
    });
    order.forEach(function (g, idx) {
      var want = g.qty;
      if (delta > 0 && idx === 0) { want = g.qty + delta; delta = 0; }
      else if (delta < 0) { var take = Math.min(-delta, g.qty); want = g.qty - take; delta += take; }
      if (want === g.qty) return;   // untouched: leave Shopify's paid/free split alone
      // one line carries the variant; the rest go to zero and Shopify re-splits the free pairs
      g.lines.forEach(function (ln, i) {
        var q = i === 0 ? want : 0;
        if (q !== ln.quantity) updates[ln.key] = q;
      });
    });
    var tier = tierFor(target);
    Object.keys(GIFT).forEach(function (vid) {
      vid = parseInt(vid, 10);
      var line = c.items.filter(function (i) { return i.variant_id === vid; })[0];
      var want = GIFT[vid] <= tier && tier >= 2 ? 1 : 0;
      var have = line ? line.quantity : 0;
      if (want !== have) updates[line ? line.key : String(vid)] = want;
    });
    return merge(updates, promoUpdates(c, tier));
  }

  function apply(updates) {
    if (!Object.keys(updates).length) return Promise.resolve();
    setBusy(true);
    return xhrJSON('/cart/update.js', { updates: updates }).then(function (c) {
      cart = c; render(); rememberCart(c); return normalize(c);
    }).catch(function () {}).then(function () { setBusy(false); });
  }

  /* Anything the drawer did not do itself (the product form, a second add)
     can leave the pairs off a tier. Snap to a tier and fix the gifts. */
  var normalizing = false;
  function normalize(c) {
    if (normalizing) return Promise.resolve();
    var m = model(c);
    var updates;
    if (!m.total) {
      updates = {};
      m.gifts.forEach(function (g) { if (GIFT[g.variant_id]) updates[g.key] = 0; });
      merge(updates, promoUpdates(c, 0));   // a kit on its own can still earn the BF/CM gifts
    } else {
      var target = m.total === 2 ? 3 : m.total === 4 ? 5 : m.total;
      updates = bundleUpdates(c, target, null);
    }
    if (!Object.keys(updates).length) return Promise.resolve();
    normalizing = true;
    return apply(updates).then(function () { normalizing = false; });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-b9c-act]');
    if (!btn || !cart) return;
    var act = btn.getAttribute('data-b9c-act');
    if (act === 'bonus') {   // no request, no repaint: just fold the list
      var box = btn.closest('.b9c__bonus');
      bonusOpen = !bonusOpen;
      box.classList.toggle('is-open', bonusOpen);
      btn.setAttribute('aria-expanded', bonusOpen ? 'true' : 'false');
      box.querySelector('.b9c__bonus-list').hidden = !bonusOpen;
      if (bonusOpen) fitLines(box);
      return;
    }
    if (busy) return;
    var m = model(cart);
    // the number changes on the press; the request catches up (busy state greys the row meanwhile)
    var out = btn.parentNode && btn.parentNode.querySelector('output');
    if (act === 'plus') {
      if (out) out.textContent = stepUp(m.total);
      apply(bundleUpdates(cart, stepUp(m.total), null));
    } else if (act === 'minus') {
      if (out) out.textContent = stepDown(m.total);
      apply(bundleUpdates(cart, stepDown(m.total), null));
    } else if (act === 'remove-insoles') {
      var updates = bundleUpdates(cart, 0, null);
      m.insoles.forEach(function (g) { g.lines.forEach(function (ln) { updates[ln.key] = 0; }); });
      apply(updates);
    } else if (act === 'line') {
      var q = parseInt(btn.getAttribute('data-b9c-qty'), 10);
      if (out) out.textContent = q;
      if (q === 0) { var ln = btn.closest('.b9c__line'); if (ln) ln.classList.add('is-leaving'); }
      var u = {}; u[btn.getAttribute('data-b9c-key')] = q;
      apply(u);
    }
  });

  // upsell add
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-b9c-add]');
    if (!btn || busy) return;
    /* One request: update.js keyed by variant adds the line and hands back
       the whole cart, so there is no second read before the repaint. */
    var vid = parseInt(btn.getAttribute('data-b9c-add'), 10);
    var have = cart ? cart.items.filter(function (i) { return i.variant_id === vid; }).reduce(function (a, i) { return a + i.quantity; }, 0) : 0;
    var u = {}; u[String(vid)] = have + 1;
    apply(u);
  });

  /* ------------------------------------------------------- open/close -- */
  var lastFocus = null;
  /* Shrine's own (hidden) cart drawer still opens itself on other product
     pages' Add to Cart and locks the body; ours closing must undo that too. */
  function unlockPage() {
    document.body.classList.remove('b9c-lock', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
    var theirs = document.querySelector('cart-drawer');
    if (theirs) { theirs.classList.remove('active', 'animate'); theirs.querySelectorAll('details[open]').forEach(function (d) { d.removeAttribute('open'); }); }
  }
  function open() {
    if (root.classList.contains('is-open')) return Promise.resolve();
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('b9c-lock');
    void root.offsetWidth;   // commit `hidden` first so the slide-in transition runs (rAF never fires in a background tab)
    root.classList.add('is-open');
    fitLines();
    panel.focus({ preventScroll: true });
    return cart ? Promise.resolve() : refresh();
  }
  function close() {
    root.classList.remove('is-open');
    unlockPage();
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-b9c-close]'), function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
  document.addEventListener('touchstart', function () {
    if (root.hidden && document.body.classList.contains('overflow-hidden')) unlockPage();
  }, { passive: true });

  // header cart icon opens the drawer instead of going to /cart
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
    if (!a || e.metaKey || e.ctrlKey || root.contains(a)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refresh().then(open, open);
  }, true);

  // a rebuilt cart from an email link lands here with ?b9cart=open (see theme.liquid): show the drawer, tidy the URL
  if (/[?&]b9cart=open/.test(location.search)) {
    try { history.replaceState(null, '', location.pathname + location.search.replace(/[?&]b9cart=open/, '').replace(/^&/, '?') + location.hash); } catch (err) {}
    refresh().then(open, open);
  }

  var checkout = $('[data-b9c-checkout]');
  if (checkout) checkout.addEventListener('click', function () { checkout.setAttribute('aria-busy', 'true'); });

  /* Anything else that touches the cart (Shrine's product form on other
     pages, an app) gets the drawer refreshed; adds open it. */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function () { setTimeout(function () { refresh().then(function () { if (isAdd) open(); }); }, 50); }, function () {});
    }
    return p;
  };

  // warm the compare-at cache for the gifts and the upsells, so adding one is one paint
  ['golfers-recovery-socks-free-gift', 'golfers-foot-relief-sleeve-free-gift', 'golfers-heel-guards-free-gift'].forEach(loadProduct);
  Array.prototype.forEach.call(root.querySelectorAll('[data-b9c-upsell][data-handle]'), function (u) { loadProduct(u.getAttribute('data-handle')); });

  /* Leaving through a menu link on a touch screen. iOS focuses a tapped link
     and scrolls the page to "reveal" it - and with the drawer fixed inside
     the sticky header, that scroll drags the drawer with it (the jump). So a
     tap is caught on the touch, the link is never focused, and the page is
     left by script with the drawer sitting exactly where it was. Desktop
     mice keep the plain link. */
  var MENU_LINK = 'header-drawer .menu-drawer__menu-item[href], header-drawer .menu-drawer__menu-item a[href]';
  function menuLinkOf(e) {
    var a = e.target.closest(MENU_LINK);
    if (!a || (a.getAttribute('href') || '').charAt(0) === '#') return null;
    var drawer = a.closest('header-drawer');
    if (!drawer || !drawer.querySelector('details[open]')) return null;
    return { a: a, drawer: drawer };
  }
  var touch = null;
  document.addEventListener('touchstart', function (e) {
    var hit = menuLinkOf(e);
    if (!hit || !e.touches || e.touches.length !== 1) { touch = null; return; }
    touch = { a: hit.a, drawer: hit.drawer, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
  }, { capture: true, passive: true });
  document.addEventListener('touchend', function (e) {
    if (!touch) return;
    var t = touch; touch = null;
    var p = e.changedTouches && e.changedTouches[0];
    if (!p || Date.now() - t.t > 700 || Math.abs(p.clientX - t.x) > 10 || Math.abs(p.clientY - t.y) > 10) return;   // a scroll or a long press
    if (e.cancelable) e.preventDefault();   // no click, no focus, no scroll
    if (document.documentElement.classList.contains('b9c-nav')) return;
    document.documentElement.classList.add('b9c-nav');   // css: page locked while we leave
    var d = t.drawer;
    if (!d._b9cClose) {   // Shrine closes the drawer when focus moves; park that until the page is gone
      d._b9cClose = { close: d.closeMenuDrawer, anim: d.closeAnimation };
      d.closeMenuDrawer = function () {};
      d.closeAnimation = function () {};
    }
    window.location.href = t.a.href;
  }, { capture: true, passive: false });
  window.addEventListener('pageshow', function (e) {   // back through the bfcache: undo the freeze
    if (!document.documentElement.classList.contains('b9c-nav')) return;
    document.documentElement.classList.remove('b9c-nav');
    var d = document.querySelector('header-drawer');
    if (d && d._b9cClose) { d.closeMenuDrawer = d._b9cClose.close; d.closeAnimation = d._b9cClose.anim; d._b9cClose = null; }
    var details = d && d.querySelector('details[open]');
    if (details) { try { d.closeMenuDrawer(e, details.querySelector('summary')); } catch (err) {} details.removeAttribute('open'); details.classList.remove('menu-opening'); }
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');
  });

  window.addEventListener('resize', function () { if (!root.hidden) fitLines(); });
  window.b9rCart = { open: open, close: close, refresh: refresh };
  document.dispatchEvent(new CustomEvent('b9r:cart-ready'));

  refresh();
})();
